// extracted by mini-css-extract-plugin
module.exports = {"Text":"Text_Text__MjvAa","Text--sizeY-compact":"Text_Text--sizeY-compact__3Bfni","Text--sizeY-none":"Text_Text--sizeY-none__Oxf2P"};